import { REQUEST_MYLICENCE_STATUS_REL } from './constants'

export const getMyLicenceStatus = (state) => state.myLicence

export const getMyLicenceSelector = (state) =>
  state.links.filter((link) => link.Rel === REQUEST_MYLICENCE_STATUS_REL)[0]
